"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AltDateWidget = require("./AltDateWidget");

var _AltDateWidget2 = _interopRequireDefault(_AltDateWidget);

var _AltDateTimeWidget = require("./AltDateTimeWidget");

var _AltDateTimeWidget2 = _interopRequireDefault(_AltDateTimeWidget);

var _BaseInput = require("./BaseInput");

var _BaseInput2 = _interopRequireDefault(_BaseInput);

var _CheckboxWidget = require("./CheckboxWidget");

var _CheckboxWidget2 = _interopRequireDefault(_CheckboxWidget);

var _CheckboxesWidget = require("./CheckboxesWidget");

var _CheckboxesWidget2 = _interopRequireDefault(_CheckboxesWidget);

var _ColorWidget = require("./ColorWidget");

var _ColorWidget2 = _interopRequireDefault(_ColorWidget);

var _DateWidget = require("./DateWidget");

var _DateWidget2 = _interopRequireDefault(_DateWidget);

var _DateTimeWidget = require("./DateTimeWidget");

var _DateTimeWidget2 = _interopRequireDefault(_DateTimeWidget);

var _EmailWidget = require("./EmailWidget");

var _EmailWidget2 = _interopRequireDefault(_EmailWidget);

var _FileWidget = require("./FileWidget");

var _FileWidget2 = _interopRequireDefault(_FileWidget);

var _HiddenWidget = require("./HiddenWidget");

var _HiddenWidget2 = _interopRequireDefault(_HiddenWidget);

var _PasswordWidget = require("./PasswordWidget");

var _PasswordWidget2 = _interopRequireDefault(_PasswordWidget);

var _RadioWidget = require("./RadioWidget");

var _RadioWidget2 = _interopRequireDefault(_RadioWidget);

var _RangeWidget = require("./RangeWidget");

var _RangeWidget2 = _interopRequireDefault(_RangeWidget);

var _SelectWidget = require("./SelectWidget");

var _SelectWidget2 = _interopRequireDefault(_SelectWidget);

var _TextareaWidget = require("./TextareaWidget");

var _TextareaWidget2 = _interopRequireDefault(_TextareaWidget);

var _TextWidget = require("./TextWidget");

var _TextWidget2 = _interopRequireDefault(_TextWidget);

var _URLWidget = require("./URLWidget");

var _URLWidget2 = _interopRequireDefault(_URLWidget);

var _UpDownWidget = require("./UpDownWidget");

var _UpDownWidget2 = _interopRequireDefault(_UpDownWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  BaseInput: _BaseInput2.default,
  PasswordWidget: _PasswordWidget2.default,
  RadioWidget: _RadioWidget2.default,
  UpDownWidget: _UpDownWidget2.default,
  RangeWidget: _RangeWidget2.default,
  SelectWidget: _SelectWidget2.default,
  TextWidget: _TextWidget2.default,
  DateWidget: _DateWidget2.default,
  DateTimeWidget: _DateTimeWidget2.default,
  AltDateWidget: _AltDateWidget2.default,
  AltDateTimeWidget: _AltDateTimeWidget2.default,
  EmailWidget: _EmailWidget2.default,
  URLWidget: _URLWidget2.default,
  TextareaWidget: _TextareaWidget2.default,
  HiddenWidget: _HiddenWidget2.default,
  ColorWidget: _ColorWidget2.default,
  FileWidget: _FileWidget2.default,
  CheckboxWidget: _CheckboxWidget2.default,
  CheckboxesWidget: _CheckboxesWidget2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/react-jsonschema-form/lib/components/widgets/index.js
// module id = 137
// module chunks = 0